import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialNewsState } from '../../models/newsModel';

export const fetchNews = createAsyncThunk(
    'news/fetchNews',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/Showcase/GetAllByNews');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const newsSlice = createSlice({
    name: 'news',
    initialState: initialNewsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.loading = false;
                state.dataNews = action.payload;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default newsSlice.reducer;
